module.exports = __webpack_public_path__ + "img/icon50.70c5176d.png";